import { Typography } from "antd";

import { FC, useContext } from "react";
import M2Icon from "shared-components/Components/CustomIcons/M2Icon";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";

interface M2TagProps {
	m2: number;
	icon?: boolean;
	hectares?: number;
	isEspecial?: Boolean;
	isMin?: Boolean;
	propertyType?: number;
}

export const M2Tag: FC<M2TagProps> = ({ m2, icon = false, hectares = 0, isEspecial, isMin = false, propertyType }) => {
	const { country_code, site_name } = useContext(ConfigStateContext);
	const normalizedSiteName = (site_name || "").toLowerCase();
	const canUseHectaresForType =
		propertyType === 6 &&
		(normalizedSiteName.includes("infocasas") || country_code !== "CO");
	const shouldShowHectares = hectares > 0 || canUseHectaresForType;
	const amount = hectares > 0 ? hectares : m2;

	return (
		<div className="typology-item-container">
			{isEspecial ? (
				<>
					{icon && <M2Icon width={18} />}
					<div style={{ display: "flex", flexDirection: "column" }}>
						<Typography.Text className="name" ellipsis>
							{"SQFT"}
						</Typography.Text>
						<Typography.Text className="count" ellipsis>
							{isMin ? "+" : ""}{amount} {shouldShowHectares ? "hectáreas" : "m²"}
						</Typography.Text>
					</div>
				</>
			) : (
				<>
					{icon && <M2Icon width={18} />}
					<Typography.Text ellipsis>
						{isMin ? "+" : ""}{amount} {shouldShowHectares ? "hectáreas" : "m²"}
					</Typography.Text>
				</>
			)}
		</div>
	);
};
